import React, { ReactElement } from 'react';
import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

import { gray40, gray80, white } from '../../../constants/colors';
import { boldMd, dialogText, dialogTitle } from '../../../constants/location';
import {
  PROXY_LOGIN_DIALOG_TITLE,
  PROXY_LOGIN_BUTTON,
  CANCEL_BUTTON,
} from '../../../constants/labels';

type Props = {
  open: boolean;
  companyName: string;
  onClose: () => void;
  onConfirm: () => void;
};

const styles = {
  buttonWrapper: {
    display: 'flex',
    gap: '16px',
    marginTop: '32px',
    '@media screen and (max-width:960px)': {
      gap: '8px',
      marginTop: '20px',
    },
  },
  cancelButton: {
    '&:hover': {
      backgroundColor: white,
      border: `1px solid ${gray80}`,
      boxShadow: 'none',
    },
    backgroundColor: white,
    border: `1px solid ${gray80}`,
    boxShadow: 'none',
    color: gray80,
    height: '44px',
    width: 'calc(50% - 8px)',
    '@media screen and (max-width:960px)': {
      width: 'calc(50% - 4px)',
    },
  },
  cancelButtonText: {
    ...boldMd,
    color: gray80,
  },
  confirmButton: {
    '&:hover': {
      backgroundColor: '#F03C0A',
      boxShadow: 'none',
    },
    backgroundColor: '#F03C0A',
    boxShadow: 'none',
    height: '44px',
    width: 'calc(50% - 8px)',
    '@media screen and (max-width:960px)': {
      width: 'calc(50% - 4px)',
    },
  },
  confirmButtonText: {
    ...boldMd,
    color: white,
  },
  dialog: {
    '& .MuiPaper-root': {
      border: '1px solid' + gray40,
      boxSizing: 'border-box',
      margin: '16px',
      padding: '40px',
      '@media screen and (max-width: 960px)': {
        padding: '32px 16px',
      },
    },
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '24px',
    '@media screen and (max-width:960px)': {
      marginBottom: '16px',
    },
  },
  icon: {
    height: '32px',
    width: '32px',
    '@media screen and (max-width:960px)': {
      height: '24px',
      width: '24px',
    },
  },
  iconButton: {
    padding: 0,
  },
  title: {
    ...dialogTitle,
    '@media screen and (max-width:960px)': {
      ...boldMd,
    },
  },
  descriptionText: {
    ...dialogText,
  },
};

const ProxyLoginConfirmDialog = ({
  open,
  companyName,
  onClose,
  onConfirm,
}: Props): ReactElement => {
  return (
    <Dialog open={open} onClose={onClose} sx={styles.dialog}>
      <Box sx={styles.header}>
        <Typography sx={styles.title}>{PROXY_LOGIN_DIALOG_TITLE}</Typography>
        <IconButton onClick={onClose} sx={styles.iconButton}>
          <Close sx={styles.icon} />
        </IconButton>
      </Box>
      <Typography sx={styles.descriptionText}>
        「{companyName}」として代理モードで操作します。よろしいですか？
      </Typography>
      <Box sx={styles.buttonWrapper}>
        <Button sx={styles.cancelButton} onClick={onClose}>
          <Typography sx={styles.cancelButtonText}>{CANCEL_BUTTON}</Typography>
        </Button>
        <Button sx={styles.confirmButton} onClick={onConfirm}>
          <Typography sx={styles.confirmButtonText}>{PROXY_LOGIN_BUTTON}</Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default ProxyLoginConfirmDialog;
